<script lang="ts">
    import type { Person } from '../../../modules/eventsApi/persons/person'
    import Content from '../../_common/content.svelte'
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import { PricingElementEntity } from './pricing-element.entity'
    import PricingElement from './pricing-element.svelte'

    let step = 3
    let maxTabs = 3

    let plan = null
    let person: Person = null

    function goNext() {
        step += 1
    }
    function goPrevious() {
        if (step === 1) return
        step -= 1
    }

    let pm: PricingElementEntity
    let pa: PricingElementEntity

    function loadPlans() {
        // migrar para o users-api
        // o cupom informado pode ser a identificação de um parceiro.

        pm = new PricingElementEntity()
        pm.planId = 'random-uuid-1'
        // condições
        pm.title = 'Mensal Full 6'
        pm.coupons = ['mensal2024']
        pm.metadata = {
            plan: 'full-6',
            items: ['wa', 'docs', 'sign'],
        }
        pm.price = 139
        pm.months = 1
        pm.installments = 1
        pm.extras.push({ checked: true, price: 29, title: 'WhatsApp integrado' })
        pm.extras.push({ checked: true, price: 29, mensal2024: 0, title: 'Documentos e assinatura' })
        pm.extras.push({ checked: true, price: 29, mensal2024: 0, title: 'Agendamento online' })
        pm.conditions = 'Pague mensalmente'
        /////
        pm.items.push({ checked: true, title: 'Até 6 agendas / usuários' })
        pm.items.push({ checked: true, title: '1 treinamento ao vivo' })
        pm.items.push({ checked: true, title: 'Suporte por WhatsApp' })
        pm.items.push({ checked: true, title: 'Financeiro' })
        pm.items.push({ checked: true, title: 'Comissões' })
        pm.items.push({ checked: true, title: 'Pagamento recorrente' })
        pm.items.push({ checked: true, title: 'Controle de estoque' })
        pm.items.push({ checked: true, title: 'CRM' })

        //////////////////////
        pa = new PricingElementEntity()
        pm.planId = 'random-uuid-2'
        pa.title = 'Anual Full 6'
        pa.coupons = ['anual2024']
        pa.metadata = {
            plan: 'full-6',
            items: ['wa', 'docs', 'sign'],
        }
        pa.items.push({ checked: true, title: 'Até 6 agendas / usuários' })
        pa.items.push({ checked: true, title: '1 treinamento ao vivo' })
        pa.items.push({ checked: true, title: 'Suporte por WhatsApp' })
        pa.items.push({ checked: true, title: 'Financeiro' })
        pa.items.push({ checked: true, title: 'Comissões' })
        pa.items.push({ checked: true, title: 'Pagamento recorrente' })
        pa.items.push({ checked: true, title: 'Controle de estoque' })
        pa.items.push({ checked: true, title: 'CRM' })
        pa.items.push({ checked: true, title: 'Automação de Marketing' })

        pa.price = 129
        pa.months = 12
        pa.installments = 12
        pa.conditions = ''

        pa.extras.push({ checked: true, price: 29, title: 'WhatsApp integrado' })
        pa.extras.push({ checked: true, price: 29, anual2024: 0, title: 'Documentos e assinatura' })
        pa.extras.push({ checked: true, price: 29, anual2024: 0, title: 'Agendamento online' })
    }

    loadPlans()
</script>

<div class="pricing-outer">
    <div class="config-box">
        <div class="config-box-in">
            <div class="config-box-in_content pb-3">
                <div class="config-box-title text-center">Zandu - Configure seu plano ideal</div>
                {#if step === 1}
                    <div class="mb-3 text-center">Primeiro selecione a pessoa responsável pelo plano:</div>
                    <div>
                        <ZentitySelect fonte="pessoa" bind:value={person}></ZentitySelect>
                    </div>
                {/if}
                {#if step === 2}
                    <div class="mb-3 text-center">
                        Escolha um plano conforme a quantidade de agendas necessárias.<br />
                        Geralmente você irá precisar de uma agenda para cada profissional que atende em seu espaço.
                    </div>
                    <div class="form-check form-check-inline">
                        <input
                            type="radio"
                            name="cboPlan"
                            bind:group={plan}
                            value="uno"
                            id="p1"
                            class="form-check-input"
                        />
                        <label for="p1">Plano Uno - 1 agenda</label>
                    </div>
                    <br />
                    <div class="form-check form-check-inline mt-2">
                        <input
                            type="radio"
                            name="cboPlan"
                            bind:group={plan}
                            value="duo"
                            id="p2"
                            class="form-check-input"
                        />
                        <label for="p2">Plano Duo - 2 agendas</label>
                    </div>
                    <br />
                    <div class="form-check form-check-inline mt-2">
                        <input
                            type="radio"
                            name="cboPlan"
                            bind:group={plan}
                            value="full-6"
                            id="p3"
                            class="form-check-input"
                        />
                        <label for="p3">Plano Full 6 - de 3 a 6 agendas</label>
                    </div>
                    <br />
                    <div class="form-check form-check-inline mt-2">
                        <input
                            type="radio"
                            name="cboPlan"
                            bind:group={plan}
                            value="full-10"
                            id="p4"
                            class="form-check-input"
                        />
                        <label for="p4">Plano Full 10 - de 7 a 10 agendas</label>
                    </div>
                    <br />
                    <div class="form-check form-check-inline mt-2">
                        <input
                            type="radio"
                            name="cboPlan"
                            bind:group={plan}
                            value="full-30"
                            id="p5"
                            class="form-check-input"
                        />
                        <label for="p5">Plano Full 30 - de 11 a 30 agendas</label>
                    </div>
                {/if}
                {#if step === 3}
                    <div class="mb-3 text-center">Agora é só escolher a forma de pagamento:</div>
                    <div class="pricing-tables">
                        <PricingElement plan={pm}></PricingElement>
                        <PricingElement plan={pa}></PricingElement>
                    </div>
                {/if}
            </div>
            <div class="config-box-in_act">
                {#if step > 1}
                    <button on:click={goPrevious} class="btn btn-secondary">Voltar</button>
                {/if}
                <div class="spacer"></div>
                {#if step < maxTabs}
                    <button on:click={goNext} class="btn btn-primary">Avançar</button>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .pricing-outer {
        background: #222;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        width: 100%;
        min-height: 100%;
    }

    .pricing-outer .config-box {
        flex-grow: 1;
        max-width: 970px;
        color: white;
    }

    .pricing-outer .config-box-in {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .config-box-in_content {
        flex-grow: 1;
    }
    .config-box-in_act {
        flex-grow: 0;
        flex-shrink: 0;
        padding: 8px;
        background-color: #99999910;
        display: flex;
        border-radius: 8px;
    }
</style>
